import { createListPage, createDetailPage } from 'pages/common'
import { api, actionCreators } from 'store/modules/flavourCharacteristicses'
import Content from './grid'
import Form from './form'

import { urls } from 'urls'

const PAGE = 'flavourCharacteristicses'

export const metadata = {
  icon: 'lemon-o',
  page: PAGE,
  isSoftDelete: false,
  urls: urls[PAGE]
}

const FlavourCharacteristicsesListPage = createListPage({ metadata, api, actionCreators, Content })
const FlavourCharacteristicsesDetailPage = createDetailPage({ metadata, actionCreators, Form })

export { FlavourCharacteristicsesListPage, FlavourCharacteristicsesDetailPage }
